
import './style.scss'

interface LabeledSelectMenuProps {
	label: string
	onChange: (newOption: boolean) => void
	isOn?: boolean
	disabled?: boolean
}

function LabeledCheckbox({label, isOn, onChange, disabled}: LabeledSelectMenuProps) {

	return (
		<div className='labeled-checkbox-wrap'>
			<input
				type='checkbox'
				className='labeled-checkbox-input'
				onChange={(event) => {
					onChange(event.target.value === 'off')
				}}
				value={isOn === true ? 'on' : 'off'}
				disabled={disabled}
			/>
			<span 
				className='labeled-checkbox-label'
				dangerouslySetInnerHTML={{ __html: label }}
			/>
		</div>
	)
}

export default LabeledCheckbox